import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { keyframes, css } from '@emotion/react'

export const PROGRESSBAR_VARIANT_DEFAULT = 'default'
export const PROGRESSBAR_VARIANT_SUCCESS = 'success'
export const PROGRESSBAR_VARIANT_ERROR = 'error'
export const PROGRESSBAR_VARIANT_NEUTRAL = 'neutral'

const step = 20

const INNER_HEIGHT = 19 // px

const slide = keyframes`
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: ${4 * Math.sqrt(2 * step * step)}px;
  }
`

const handleVariant = ({ variant }) => {
  switch (variant) {
    case PROGRESSBAR_VARIANT_DEFAULT:
      return 'border-color: var(--amber);'
    case PROGRESSBAR_VARIANT_SUCCESS:
      return 'border-color: var(--sushi);'
    case PROGRESSBAR_VARIANT_ERROR:
      return 'border-color: var(--persimmon);'
      case PROGRESSBAR_VARIANT_NEUTRAL:
      return 'border-color: var(--silver);'
  }
}

const handleBarVariant = ({ variant }) => {
  switch (variant) {
    case PROGRESSBAR_VARIANT_DEFAULT:
      return css`
        animation: ${slide} 4s linear infinite;
        will-change: background-position;

        background-color: var(--mustard);
        background-image: repeating-linear-gradient(
          45deg,
          transparent,
          transparent ${step}px,
          var(--amber) ${step}px,
          var(--amber) ${step * 2}px
        );
      `
    case PROGRESSBAR_VARIANT_SUCCESS:
      return `
        background-color: var(--mantis);
        background-image: repeating-linear-gradient(
          45deg,
          transparent,
          transparent ${step}px,
          var(--sushi) ${step}px,
          var(--sushi) ${step * 2}px
        );
      `

    case PROGRESSBAR_VARIANT_ERROR:
      return `
        background-color: var(--vivid-tangerine);
        background-image: repeating-linear-gradient(
          45deg,
          transparent,
          transparent ${step}px,
          var(--persimmon) ${step}px,
          var(--persimmon) ${step * 2}px
        );
      `
      case PROGRESSBAR_VARIANT_NEUTRAL:
        return `
          background-color: var(--silver02);
          background-image: repeating-linear-gradient(
            45deg,
            transparent,
            transparent ${step}px,
            var(--silver) ${step}px,
            var(--silver) ${step * 2}px
          );
        `
  }
}

const StyledContainer = styled.div`
  position: relative;
  overflow: hidden;

  min-height: 25px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  padding: 1px;

  border-width: 2px;
  border-style: solid;
  border-radius: 13.5px;
  ${handleVariant}
`

const StyledBar = styled.div`
  height: ${INNER_HEIGHT}px;


  border-radius: ${INNER_HEIGHT / 2}px;

  background-size: ${4 * Math.sqrt(2 * step * step)}px
    ${4 * Math.sqrt(2 * step * step)}px;

  width: ${({ width }) => width}%;
  

  ${handleBarVariant}


  clip-path: path('M ${INNER_HEIGHT / 2} ${INNER_HEIGHT} A ${INNER_HEIGHT /
  2},${INNER_HEIGHT / 2}, 0,0,1 ${INNER_HEIGHT /
  2} 0 L 9999 0 L 9999 ${INNER_HEIGHT}');

  overflow: hidden;
`

const StyledContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ProgressBar = ({ className, children, variant, width }) => {
  return (
    <StyledContainer variant={variant}>
      <StyledBar variant={variant} width={width} />
      <StyledContent>{children}</StyledContent>
    </StyledContainer>
  )
}

ProgressBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  width: PropTypes.number,
  variant: PropTypes.oneOf([
    PROGRESSBAR_VARIANT_DEFAULT,
    PROGRESSBAR_VARIANT_SUCCESS,
    PROGRESSBAR_VARIANT_ERROR,
    PROGRESSBAR_VARIANT_NEUTRAL
  ])
}

ProgressBar.defaultProps = {
  variant: PROGRESSBAR_VARIANT_DEFAULT
}
